module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/High_Stakes2#Contents-A"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("My thanks to faithful sources of encouragement Frier C. McCollister, Kirk Borland, the Tilton family, Joe Hoy, and Gwen Macsai; to William M. Sheridan and Eoin Purcell for valuable advice; and to editor Barbara Peters and the dedicated staff at Poisoned Pen Press for their continued expertise.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4faf22f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/High_Stakes-4.vue
// module id = 72
// module chunks = 0